class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => this.handleClick(event));
  }

  handleClick(event) {
    event.preventDefault();
    const cartItems =
      this.closest("cart-items") || this.closest("cart-item-list");
      cartItems.updateQuantity(this.dataset.index, 0);
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="discount"]');
        this.inputValue = this.input.value;
        this.remove = this.querySelector('[data-discount-remove]');
        this.error = this.querySelector('.cart_discount_error');
        this.wrapper = this.closest('cart-drawer') || this.closest('main-cart');
        this.sectionId = this.dataset.sectionId || 'main-cart';
  }

  connectedCallback() {
        this.input.addEventListener('input', this.handleInput.bind(this));
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        if(this.remove) {
            this.remove.addEventListener('click', this.handleRemove.bind(this));
        }
    }

    handleInput(e) {
        e.preventDefault();
        this.inputValue = this.input.value;
    }

    handleFormSubmit(e) {
      e.preventDefault();

      this.classList.add('loading')

      const formData = {
        discount: this.inputValue,
        sections: `cart-drawer,cart-icon-bubble,${this.sectionId}`
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': "application/json"
        },
        body: JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((cartData) => {
        if(cartData.discount_codes[0].applicable == false) {
          if(this.error) {
            this.error.classList.remove('hidden');
            this.input.value = "";
          } 

          this.classList.remove('loading')
        } else {         
          const cartWr = this.closest('.drawer__bottom') || this.closest('.cart_footer--wrapper');
          const cartItems = cartWr.previousElementSibling;          
          const parsedState = cartData;

          cartItems.getSectionsToRender().forEach((section) => {
            console.log(section)
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        }
      })
    }

    handleRemove(e) {
      e.preventDefault();

      this.classList.add('loading');     

      const formData = {
        discount: "",
        sections: `cart-drawer,cart-icon-bubble,${this.sectionId}`
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': "application/json",
        },
        body: JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((cartData) => {
          const cartWr = this.closest('.drawer__bottom') || this.closest('.cart_footer--wrapper');
          const cartItems = cartWr.previousElementSibling; 
          const parsedState = cartData

          cartItems.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
      })
    }
}

customElements.define('cart-discount', CartDiscount);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    // document.addEventListener('cart-update', (e) => {
    // const cart = e.detail.item_count;
    // console.log('Cart', cart)
    //   this.updateCartDrawer(cart);
    // })
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );

    // BUTTON HOVER ON CART DRAWER UPDATE
    const btns = document.querySelectorAll(".btn");
    btns.forEach(function (btn) {
      btn.addEventListener("mouseenter", function (e) {
        const parentOffset = btn.getBoundingClientRect();
        const relX = e.clientX - parentOffset.left;
        const relY = e.clientY - parentOffset.top;

        const span = btn.querySelector("span");
        if(span) {
          span.style.top = `${relY}px`;
          span.style.left = `${relX}px`;
        }        
      });

      btn.addEventListener("mouseout", function (e) {
        const parentOffset = btn.getBoundingClientRect();
        const relX = e.clientX - parentOffset.left;
        const relY = e.clientY - parentOffset.top;
        const span = btn.querySelector("span");
        if(span) {
          span.style.top = `${relY}px`;
          span.style.left = `${relX}px`;
        }        
      });
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    const sectionId = this.dataset.sectionId || (this.tagName === "CART-ITEM-LIST" ? "cart-drawer" : "main-cart-items");
    const isCartItemList = this.tagName === "CART-ITEM-LIST";

    fetch(`${routes.cart_url}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        this.updateCartUI(responseText, isCartItemList);
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            if (typeof shippingBar === 'function') {
              shippingBar(cart.total_price, cart.currency);
            }
            // Dispatch cart:updated event for other listeners (like free gift check)
            window.dispatchEvent(new CustomEvent('cart:updated', { 
              detail: { cartData: cart } 
            }));
          });
      })
      .catch(this.handleCartUpdateError);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);
      
      const sectionId = section.section || section.id;
      if (elementToReplace && parsedState.sections && parsedState.sections[sectionId]) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[sectionId],
          section.selector
        );
      }
    });

    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        if (typeof shippingBar === 'function') {
          shippingBar(cart.total_price, cart.currency);
        }
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cartData: cart } }));
      });
  }

  //updateCartUI

  updateCartUI(responseText, isCartItemList) {
    const html = new DOMParser().parseFromString(responseText, "text/html");
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    
    if (isCartItemList) {
      this.replaceElement(
        "#cart-item-list",
        html.querySelector("cart-item-list")
      );
    } else {
      const cartItems = html.querySelector("cart-items");
      if (cartItems) this.innerHTML = cartItems.innerHTML;

      const cartFooter = html.querySelector("#cart-footer-section");
      if (cartFooter) {
        const targetFooter = document.getElementById("cart-footer-section");
        if (targetFooter) targetFooter.innerHTML = cartFooter.innerHTML;
      }

      const freeGift = html.querySelector(".cart_free_gift_wrapper");
      if (freeGift) {
        const targetFreeGift = document.querySelector(".cart_free_gift_wrapper");
        if (targetFreeGift) {
          targetFreeGift.innerHTML = freeGift.innerHTML;
          targetFreeGift.style.display = freeGift.style.display;
        }
      }
    }
  }

  replaceElement(selector, newElement) {
    if (newElement) document.querySelector(selector)?.replaceWith(newElement);
  }  

  // updateCartDrawer

  updateCartDrawer(html) {
    console.log(html)
      [("cart-item-list", ".cart-drawer__footer")].forEach((selector) => {
        const target = document.querySelector(selector);
        const source = html.querySelector(selector);
        target?.replaceWith(source);
      });       
  }

  handleCartUpdateError(error) {
    console.error("Failed to update the cart:", error);
  }

  getSectionsToRender() {
    const sections = [
      {
        id: "main-cart-section",
        section: this.dataset.sectionId,
        selector: ".cart_items_main--inner",
      },      
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      }           
    ];

    if (document.getElementById("cart-footer-section")) {
      sections.push({
        id: "cart-footer-section",
        section: this.dataset.sectionId,
        selector: "#cart-footer-section"
      });
    }

    return sections;
  }

  getSectionId(id) {
    const element = document.getElementById(id);
    return element ? element.dataset.id : id;
  }

  //updateQuantity

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("cart-footer-section");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__empty-state"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });

        const cartUpdatedEvent = new CustomEvent("cart:updated", {
          detail: {
            cartData: parsedState,
          },
        });
        window.dispatchEvent(cartUpdatedEvent);
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
  }

  // update live regions

  updateLiveRegions(line, message) {
    this.updateErrorMessage(line, message);
    this.updateAriaAttributes();
  }

  updateErrorMessage(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      const errorText = lineItemError.querySelector(".cart-item__error-text");
      if (errorText) errorText.innerHTML = message;
    }
  }

  updateAriaAttributes() {
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", true);
    }

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");

    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);
      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const element = parsedHTML.querySelector(selector);
    return element ? element.innerHTML : null;
  }

  // loading

  enableLoading(line) {
    const mainCartItems = this.getMainCartItemsElement();
    mainCartItems.classList.add("cart__items--disabled");

    this.toggleLoadingSpinners(line);

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  getMainCartItemsElement() {
    return (
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems")
    );
  }

  toggleLoadingSpinners(line) {
    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );
  }

  disableLoading(line) {
    const mainCartItems = this.getMainCartItemsElement();
    if (mainCartItems) {
      mainCartItems.classList.remove("cart__items--disabled");
    }

    this.toggleLoadingSpinners(line, true);
  }

  getMainCartItemsElement() {
    return (
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems")
    );
  }

  toggleLoadingSpinners(line, hide = false) {
    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    const action = hide ? "add" : "remove";

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList[action]("hidden")
    );
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNotebox extends HTMLElement {
      constructor() {
        super();

        this.addEventListener("input", (event) => {
          const body = JSON.stringify({ note: event.target.value });

          //  fetch call to update the cart note
          fetch(routes.cart_update_url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body,
          });
        });
      }
    }
  );
}



